import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { withSettings } from '../withSettings';
import { reducer } from '../text/reducer';
import { TextPreview } from '../text/preview';
import { mapStateToProps, mapDispatchToProps } from '../text/container';
import { DateForm } from './form';
const mapStateToPropsDate = (state, props) => {
    const date = state[props.componentIdent].content;
    return {
        ...mapStateToProps(state, props),
        date,
        content: date ? date.toLocaleDateString(navigator.language) : '',
    };
};
export const DatePreviewContainer = compose(withReducer(reducer), connect(mapStateToPropsDate, null))(TextPreview);
export const DateFormContainer = compose(withReducer(reducer), connect(mapStateToPropsDate, mapDispatchToProps))(withSettings(DateForm));
//# sourceMappingURL=container.js.map